const state = {
    microAppsUrlParams: undefined,
    marketplaceId: undefined,
    transactionId: undefined,
    gstDataQuery: undefined,
    udyamDataPass: undefined,
    videoKycScheduledDateTime: undefined,
    fssaiDataPass: undefined,
    fdaDataPass: undefined,
    shopAndEstablishmentDataPass: undefined,
    otherDataPass: undefined
};
export default state;
